<template>
    <div class="card border-0 shadow-sm h-100">
      <div class="card-body text-center">
          <div class="display-4 mb-3">
            <img v-if="img"
                :src="require(`@/assets/img/flaticon/${img}`)"
                class="img-fluid"
                style="width:65px"
                :alt="img"
              />
            <icon v-if="fa" :name="fa" scale="4" :title="title" class="text-muted" />
          </div>
          <div style="height: 100px;">
            <h3>{{ title }}</h3>
          </div>
          
          <p class="text-muted">
              {{ desc }}
          </p>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    img: String,
    fa: String,
    scale: Number,
    title: String,
    desc: String
  },
};
</script>





// WEBPACK FOOTER //
// src/components/cService.vue